import { render, staticRenderFns } from "./MostSoldItemsChart.vue?vue&type=template&id=78fa2a3c"
import script from "./MostSoldItemsChart.vue?vue&type=script&lang=js"
export * from "./MostSoldItemsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports